define('view/disclosure/modals/reviewer.assignment.modal',['require','exports','module','underscore','backbone','uikit/uikit','blockit','backbone.radio','fukit','behavior/button.search.input.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _       = require('underscore'),
      Backone = require('backbone'),
      UIKit   = require('uikit/uikit'),
      BlocKit = require('blockit'),
      Radio   = require('backbone.radio'),

      //Behaviors
      ModalSaveButtonBehavior = require('fukit').ModalSaveButtonBehavior;
      ButtonSearchInputBehavior = require('behavior/button.search.input.behavior');

  var ReviewerAssignmentModal = UIKit.Modal2.extend({
    className: 'ui modal confirmation',

    options: _.extend({}, UIKit.Modal2.prototype.options, { closable: true }),

    header: {
      type: UIKit.Modal2.HeaderView,
      text: 'Select Next Reviewer',
    },

    behaviors: {
      InvokeMethodOnEventBehavior: {
        events: {
          'unsavedChangesModal:deny deny': {
            useModelAsTarget: true,
            method: 'clearReviewer',
          },
        },
        behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
      },
    },

    content: function() {

      return {
        type: UIKit.Modal2.ContentView,
        components: [
          {
            type: UIKit.Input.extend({
              internalViewOptions: {
                button: function() {
                  return {
                    icon: 'search'
                  }
                }
              },

              initialize: function() {
                UIKit.Input.prototype.initialize.apply(this, arguments);

                this.on('focus', function() {
                  $("#AddReviewer").addClass('disabled');
                })
              }
            }),
            placeholder: 'Search for reviewer...',
            fluid: true,
            model: this.getOption('model'),
            button: true,
            typeAheadFind: true,
            behaviors: {
              ButtonSearchInputBehavior: {
                behaviorClass: ButtonSearchInputBehavior,
                queryFields: ['fullName'],
                autocompleteCollection: this.getOption('availableReviewersCollection'),
                disclosureOwnerUserId: this.getOption('disclosureOwnerUserId'),
                autocompleteDropdownBindings: {
                  text: 'lastNameFirstName',
                },
                onResultSelected: function(result, context) {
                  var previousReviewerModel = Radio.channel('AppKit.resourceService').request('resource', 'previousReviewerModel');
                  var selectedModel = result.model;
                  var viewModel = context.view.model;

                  previousReviewerModel.set({
                    user: viewModel.get('disclosureReviewer'),
                    type: 'lastAssignedReviewer',
                  });
                  viewModel.set({
                    disclosureReviewer: selectedModel.toJSON(),
                  });

                  $("#AddReviewer").removeClass('disabled');
                },
              }
            }
          }
        ],
      };
    },

    actions: function() {
      return {
        components: [
          {
            type: UIKit.Modal2.DenyButtonView,
            text: 'Cancel',
          },
          {
            type: UIKit.Modal2.ConfirmButtonView,
            text: 'Add Reviewer',
            id: 'AddReviewer',
            disabled: true,
            model: this.getOption('model'),
            behaviors: {
              ModalSaveButtonBehavior: {
                behaviorClass: ModalSaveButtonBehavior,
              },
              InvokeMethodOnEventBehavior: {
                events: {
                  press: {
                    method: function() {
                      var workflowTaskModel = Radio.request('AppKit.resourceService', 'resource', 'workflowTaskModel');
                      var disclosureModel = Radio.request('AppKit.resourceService', 'resource', 'disclosure');
                      var previousReviewerModel = Radio.request(
                        'AppKit.resourceService',
                        'resource',
                        'previousReviewerModel'
                      );

                      if (
                        !_.isUndefined(disclosureModel.get('disclosureReviewerUserId')) &&
                        !_.isNull(disclosureModel.get('disclosureReviewerUserId')) &&
                        disclosureModel.get('disclosureReviewerUserId') !== ''
                      ) {
                        previousReviewerModel.set({
                          taskId: workflowTaskModel.id,
                          user: disclosureModel.get('disclosureReviewerUserId'),
                          type: 'lastAssignedReviewer',
                        });

                        previousReviewerModel.save();
                      }
                    },
                  },
                },
                behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
              },
            },
          },
        ],
      };
    },
  });

  module.exports = ReviewerAssignmentModal;
});

